import React, { useMemo } from "react";

import { Parking } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../LightTable";
import { CompaniesByIds } from "../../../../../../common";

const CompanyCellContent: React.FC<CompanyCellContent.Props> = ({ item }) => {
	const lang = useTypedSelector((state) => state.session.language);
	const content = useMemo(
		() => item.taxiServiceId ?? "",
		[item.taxiServiceId],
	);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="6px"
			cursor="pointer"
		>
			<CompaniesByIds taxiServiceIds={[content]} lang={lang} />
		</CellContentRoot>
	);
};

declare namespace CompanyCellContent {
	interface Props {
		item: Parking.Model;
	}
}

export default CompanyCellContent;
